import { take, put } from "redux-saga/effects";
import { GET_SCHOOL_TEACHERS, getSchoolTeachersActions } from "../../actions/schools";

// services
import { getCampusTeachers } from "../../../services/http/schools";

// types
import { GetCampusUsersResponseTypes } from "../../actions/schools/types";

import * as Effects from "redux-saga/effects";
const call: any = Effects.call;

function* watchGetSchoolTeachersRequest() {
  while (true) {
    const { payload }: IActionType<{ campusId: number | undefined }> = yield take(GET_SCHOOL_TEACHERS.REQUEST);

    try {
      const result: GetCampusUsersResponseTypes = yield call(getCampusTeachers, payload);
      yield put(getSchoolTeachersActions.success(result));
    } catch (e) {
      yield put(getSchoolTeachersActions.error(e as any));
    }
  }
}

export default watchGetSchoolTeachersRequest;
